import { FC } from 'react';
import { Box, Flex, Image } from '@chakra-ui/react';

import shieldImg from 'assets/brand/shield@2x.png';
import config from 'config';
import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import IconButton from 'components/_core/IconButton';
import Text from 'components/_core/Text';
import { logEvent } from 'features/Analytics/analytics';

import locales from './locales';
import { savePanelVisibilityState } from './utils';

interface RcProSidebarProps {
  onClose: () => void;
}

const RcProSidebar: FC<RcProSidebarProps> = ({ onClose }) => {
  const onCloseButtonClick = () => {
    savePanelVisibilityState('hidden');
    onClose();
    logEvent({ name: 'Quotes RC Pro Panel Closed' });
  };

  return (
    <Box padding="space-24">
      <Flex justifyContent="flex-end">
        <IconButton
          aria-label=""
          icon="cross"
          onClick={onCloseButtonClick}
          variant="secondary"
        />
      </Flex>

      <Image
        alt=""
        height="90px"
        marginBottom="space-24"
        role="presentation"
        src={shieldImg}
      />

      <Heading marginBottom="space-16">{locales.title}</Heading>

      {locales.description.map((text) => (
        <Text key={text} marginBottom="space-12">
          {text}
        </Text>
      ))}

      <Button
        as="a"
        href={config.assurupWidgetUrl}
        icon="link"
        onClick={() => logEvent({ name: 'RC Pro Assurup Widget Clicked' })}
        target="_blank"
        variant="inline-secondary"
      >
        {locales.knowMore}
      </Button>
    </Box>
  );
};

export default RcProSidebar;
